exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".empty-cart[data-v-3118cd30]{margin:3.5rem 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3118cd30&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/EmptyCart.vue
// module id = 352
// module chunks = 0